module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-lg-between"
  }, [_c('div', {
    staticClass: "col-md-12 g-pt-50 g-pt-100--md g-pb-70"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 g-mb-30"
  }, [_c('article', [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Frames')
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid mb-4",
    attrs: {
      "src": _vm.CNN_Bottom_Left,
      "alt": "Image Description"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Adopt-a-School Today!")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-18--md g-font-size-17",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_vm._v("\n                  OneSight EssilorLuxottica Foundation encourages eye doctors to pledge to Adopt-a-School this year to provide vision care to local students with the support of Changing Life through Lenses® free glasses. Go to the Resources page to get started.\n                ")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-30 g-px-25 g-py-13 mr-2 g-font-size-18",
    attrs: {
      "href": "/Portal/Resources"
    }
  }, [_vm._v("Get Started")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 g-mb-30"
  }, [_c('article', [_c('a', {
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Help')
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid mb-4",
    attrs: {
      "src": _vm.CNN_Top_Right,
      "alt": "Image Description"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The New OneSight EssilorLuxottica Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-18--md g-font-size-17",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_vm._v("As the leading global vision care foundation, OneSight EssilorLuxottica Foundation is committed to helping\ncontribute to eliminating uncorrected poor vision in a generation by creating sustainable access through an innovative approach to impact philanthropy, partnerships and raising awareness.\n")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-main g-bg-primary--hover g-rounded-30 g-px-25 g-py-13 mr-2 g-font-size-18",
    attrs: {
      "href": "https://onesight.essilorluxottica.com/",
      "target": "_blank"
    }
  }, [_vm._v("Learn More")])])], 1)])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-84e3e648", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84e3e648"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomePromo.vue
// module id = 534
// module chunks = 3